@if (!authCheckComplete) {
  <div class="app-loader"></div>
} @else {
  @if (isAuthenticated) {
    <div>
      @if (!isIframe) {
        <router-outlet />
      }
    </div>
  } @else {
    <div class="app-loader"></div>
  }
}
<p-confirmDialog />
